import ImpersonateIcon from 'atoms/Icons/Impersonate';
import React from 'react';

import s from './ImpersonatingUser.module.scss';

interface ImpersonatingUserProps {
  email?: string;
}

const ImpersonatingUser = ({ email }: ImpersonatingUserProps) => {
  return (
    <span className={s.ImpersonatingUser}>
      <ImpersonateIcon width="30" height="30" />
      <span className={s.ImpersonatingUser__info}>
        <span className={s.ImpersonatingUser__caption}>Impersonate mode</span>
        <strong className={s.ImpersonatingUser__email}>{email}</strong>
      </span>
    </span>
  );
};

export default ImpersonatingUser;
